
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"icon-clear","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M23.13 18.13a3.55 3.55 0 012.5 1L44.53 38a3.53 3.53 0 01.53 4.27L29 58.3 5.3 34.6l16-16a3.53 3.53 0 011.8-.46m0-3a6.44 6.44 0 00-3.7 1.12L1.07 34.62 29 62.52l18.37-18.35a6.5 6.5 0 00-.72-8.3L27.75 17a6.56 6.56 0 00-4.62-1.85z"}}),_c('path',{staticClass:"svg-n svg-m",attrs:{"d":"M46.36 44.6L19 17.3M8.76 41.2l17.1-17.08M20.38 52.8l7.52-7.5"}}),_c('path',{attrs:{"d":"M58.86 3.74a1.1 1.1 0 01.76.28 1.08 1.08 0 010 1.52L38 27.12l-1.5-1.52L58.1 4a1.1 1.1 0 01.77-.28m0-3A4.08 4.08 0 0056 1.9L32.25 25.6 38 31.36l23.75-23.7a4 4 0 00-2.9-6.92z"}})]),_c('circle',{staticClass:"svg-n svg-m",attrs:{"cx":"50","cy":"56","r":"2.83"}})])
          )
        }
      }
    